import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@/hooks/use-toast";
import {
  changeProfessionalStatus,
  ChangeProfessionalStatusInput,
} from "../services/change-professional-status";

export function useChangeProfessionalStatus(professionalId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ChangeProfessionalStatusInput) =>
      changeProfessionalStatus(professionalId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["professionals"] });
      queryClient.invalidateQueries({
        queryKey: ["professional-status-logs", professionalId],
      });
      toast({ title: "Status changed" });
    },
    onError: (error: unknown) => {
      const message =
        (error as { response?: { data?: { message?: string } } })?.response
          ?.data?.message ?? "Failed to change status";
      toast({ title: message, variant: "destructive" });
    },
  });
}
